export class PoItemModel {
    poSurrKey: number = 0;
    poDocDate: string = "";
    poItemName: string = "";
    companyName: string = "";
    poSupplierName: string = "";
    poQuantity: number = 0;
    poUnit: string = "";
    poUnitPerPrice: number = 0;
    poVat: number = 0;
    poAmount: number = 0;
    poDeliverTo: string = "";
    poCredit: string = "";
    poCostCode: string = "";
}
